export default {
  validation: {
    level: false,
    idKotaKab: false
  },
  currentPage: 0,
  instruktur: [],
  mataUji: [],
  levelPeruntukan: [],
  kotaKab: [],
  modelLevelPeruntukan: [],
  option_grader: [],
  formData: {
    idKategoriRpl: "01f1e25a-f337-49c2-9754-13a9682f1912",
    instrukturSertifikasiRplRequest: [
      {
        idInstrukturRpl: "",
        instruktur: "",
        keterangan: "",
        nilai: "",
        invalid_instruktur: false,

        },
      ],
      dokumenPendukungSertifikasiRplRequest: [
        {
          idMasterDokumenPendukung: "",
          invalid_dokumen : false,
        },
      ],
      dokumenPersyaratanSertifikat: [
        {
            idDokumenPendukung : "",
            idMasterDokumen: "",
            invalid_dokumen : false,
            modelMultiSelect: [],
        },
      ],
      sertifikasiRplMataUjiRequest: [
        {
          idMasterMataUji: "",
          deskripsi: "",
          modelMultiSelect: [],
          batasNilai: "",
          graderSatu: "",
          graderDua: "",
          modelGraderDua: [],
          modelGraderSatu: [],
          invalid_mata_uji : false,
        },
      ],
      kodeRpl: "",
      namaRpl: "",
      idLevel: "",
      baseUrl: "",
      biaya: 0,
      biayaMengulang: 0,
      tanggalDimulai: "",
      tanggalBerakhir: "",
      lokasi: "",
      idKotaKab: "",
      kategori: "",
      kategoriCpai: "",
      kapasitas: "",
      status: "",
      biayaPerMataUji: 0,
      skpTerstruktur: "",
      skpNonTerstruktur: "",
      skpAssessment: "",
    },
  };
